const getURL = () => {
  const prodEnvUrl = 'https://sb2wsdk-altenar2.biahosted.com/altenarWSDK.js';
  const stageEnvUrl = 'https://sb2wsdk-cdn-altenar2-stage.biahosted.net/altenarWSDK.js';

  return window.SYS_CONFIG?.env === 'production' ? prodEnvUrl : stageEnvUrl;
};

export const loadAltenarScript = () => {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-altenar]')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = getURL();
    script.async = true;
    script.dataset.altenar = 'true';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Altenar script'));

    document.head.appendChild(script);
  });
};
